/* eslint-disable */
import { useForm, useFormState } from "react-final-form";
import ProductAutocomplete from "./productInput";
import { CURRENCY_SYMBOLS } from "./constant";

export default function ProductDetails() {
  const form = useForm();
  const { values } = useFormState();
  const products = values?.items || [
    {
      name: "",
      quantity: "",
      unit: "",
      rate: "",
      discount: "",
      amount: "",
    },
  ];

  const setProducts = (newProducts) => {
    form.change("items", newProducts);
  };

  const handleChange = (index, field, value) => {
    const updated = [...products];
    updated[index][field] = value;
    // Optionally recalculate amount here
    setProducts(updated);
  };

  const addProduct = () => {
    setProducts([
      ...products,
      {
        name: "",
        quantity: "",
        unit: "",
        rate: "",
        discount: "",
        amount: "",
      },
    ]);
  };

  const removeProduct = (index) => {
    setProducts(products.filter((_, i) => i !== index));
  };

  const calculateAmount = (product) => {
    const { quantity, rate, discount } = product;
    const amount = quantity * rate;
    return amount.toFixed(2);
  };
  console.log("valuess", values);
  return (
    <div className="form-group-item">
      <div className="card-table">
        <div className="card-body">
          <div className="table-responsive no-pagination">
            <table className="table table-center table-hover datatable">
              <thead className="thead-light">
                <tr>
                  <th>Product</th>
                  <th>Quantity</th>
                  <th>Unit</th>
                  <th>Rate</th>
                  <th>Amount</th>
                  <th className="no-sort">Action</th>
                </tr>
              </thead>
              <tbody>
                {products.map((product, idx) => (
                  <tr key={idx}>
                    <td>
                      {/* <ProductAutocomplete
                        type="text"
                        className="form-control"
                        value={product}
                        onChange={(value) => {
                          handleChange(idx, "product", value?.value);
                          handleChange(idx, "label", value?.label);
                        }}
                      /> */}
                      <input
                        type="text"
                        // placeholder="Enter Product Name"
                        className="form-control"
                        value={product.product}
                        onChange={(e) =>
                          handleChange(idx, "product", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control"
                        value={product.quantity}
                        onChange={(e) =>
                          handleChange(idx, "quantity", Number(e.target.value))
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={product.unit}
                        onChange={(e) =>
                          handleChange(idx, "unit", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control"
                        value={product.rate}
                        onChange={(e) =>
                          handleChange(idx, "rate", Number(e.target.value))
                        }
                      />
                    </td>

                    <td>
                      {window.COMPANY.currency_symbol}{" "}
                      {calculateAmount(product)}
                    </td>
                    <td>
                      <span onClick={() => removeProduct(idx)}>
                        <i className="fe fe-trash-2" />
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div
              onClick={addProduct}
              className="mt-2"
              style={{
                backgroundColor: 'rgb(117, 57, 255)',
                height: 42,
                width: 'fit-content',
                padding: 10,
                display: 'flex',
                borderRadius: 7,
                alignItems: "center",
                color: ' #ffffff',
                cursor: 'pointer',
              }}
            >
              Add Product
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
